import { EmployeeOnlySendMessageComponent } from "./../new-v2-component/employee-only-send-message/employee-only-send-message.component";
import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AlertService } from "src/app/providers/alert.service";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { DialogService } from "src/app/providers/dialog.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { LocationService } from "src/app/providers/location.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { EmployeeChatComponent } from "src/app/shared/components/employee-chat/employee-chat.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { CopyLinkCompComponent } from "../new-v2-component/copy-link-comp/copy-link-comp.component";
import { Platform } from "@ionic/angular";

@Component({
  selector: "sm-new-business-details",
  templateUrl: "./new-business-details.component.html",
  styleUrls: ["./new-business-details.component.scss"],
})
export class NewBusinessDetailsComponent implements OnInit, OnDestroy {
  employeeFunctionalityList: any = [];

  entityHashId: string = "";
  businessDefaultImage: string | null = null;
  entityFeatureWiseCounts: any = {};
  loader: boolean = false;
  _entityDetails: any[] = [];
  appFunctionality: any = [];
  toShowCheckHome: number = 1;
  toShowCheckShop: number = 1;
  toShowCheckVirtual: number = 1;
  toShowCheckDutyStatus: number = 1;
  isEntityIndividual: boolean = false;
  senderHashId: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  receiverHashId: any = "";
  previousChatHash: any = "";
  isEntityForeign: string = "";
  private _apiSubscription: Subscription = new Subscription();
  constructor(
    private _apiService: ApiService,
    private authService: AuthService,
    private navservice: NavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private loaderService: LoaderServiceService,
    private locationService: LocationService,
    private alertService: AlertService,
    private dialogService: DialogService,
    private platform: Platform
  ) {
    this.navservice.hideSidebarAndNav = false;
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT) {
        this.isEntityIndividual = false;
        console.log(resData);
        if (resData.result && resData.result != null) {
          this._entityDetails = [];
          this._entityDetails.push(resData.result[0]);
          localStorage.setItem(
            SM_CONSTANTS.CURRENT_ENTITY_NAME,
            this._entityDetails[0].entityName
          );
          localStorage.setItem(
            SM_CONSTANTS.CURRENT_ENTITY_HASH,
            this._entityDetails[0].hashId
          );

          this.toShowCheckHome = resData.result[0].homeServiceStatus;
          this.toShowCheckShop = resData.result[0].shopServiceStatus;
          this.toShowCheckVirtual = resData.result[0].virtual_service_status;
          this.toShowCheckDutyStatus =
            resData.result[0].employee_entry_type ?? 0;

          this._entityDetails[0].entity_services =
            typeof this._entityDetails[0].entity_services == "string"
              ? JSON.parse(this._entityDetails[0].entity_services)
              : this._entityDetails[0].entity_services;

          sessionStorage.setItem(
            "isEntityIndividual",
            this._entityDetails[0].revenue_model == 2 ? "1" : "0"
          );
          this._entityDetails[0].addressInfo =
            typeof this._entityDetails[0].addressInfo == "string"
              ? JSON.parse(this._entityDetails[0].addressInfo)
              : this._entityDetails[0].addressInfo;

          this._entityDetails[0].assetInfo =
            this._entityDetails[0].assetInfo &&
            typeof this._entityDetails[0].assetInfo == "string"
              ? JSON.parse(this._entityDetails[0].assetInfo)
              : this._entityDetails[0].assetInfo;

               this._entityDetails[0].advance_payment_settings =
            this._entityDetails[0].advance_payment_settings &&
            typeof this._entityDetails[0].advance_payment_settings == "string"
              ? JSON.parse(this._entityDetails[0].advance_payment_settings)
              : this._entityDetails[0].advance_payment_settings;


          if(this._entityDetails[0].advance_payment_settings){
            sessionStorage.setItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS, JSON.stringify(this._entityDetails[0].advance_payment_settings))
          }else{
            sessionStorage.removeItem(SM_CONSTANTS.ENTITY_ADVANCE_PAYMENT_SETTINGS)
          }        
          // filteration of entity asset
          this.businessDefaultImage = null;
          if (
            this._entityDetails[0].assetInfo &&
            this._entityDetails[0].assetInfo.length > 0
          ) {
            const index_of_logo = this._entityDetails[0].assetInfo.findIndex(
              (asset: any) => asset.asset_usage_type == 2
            );

            if (index_of_logo != -1) {
              this.businessDefaultImage =
                this._entityDetails[0].assetInfo[index_of_logo].imageThumbUrl;
              // this._entityDetails[0].assetInfo.splice(index_of_logo,1)
            }
          }

          localStorage.setItem(
            SM_CONSTANTS.CURRENT_ENTITY_ADDRESS,
            this._entityDetails[0].addressInfo.address_line
          );
          localStorage.setItem(
            "entAddressInfo",
            JSON.stringify(this._entityDetails[0].addressInfo)
          );

          localStorage.setItem(
            SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
            this._entityDetails[0].employee_hash_id
          );

          localStorage.setItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
            this._entityDetails[0].entPubHash
          );
          this.isEntityForeign =
            this._entityDetails[0].currency == "INR" ? "0" : "1";

          localStorage.setItem(
            SM_CONSTANTS.IS_ENTITY_FOREIGN,
            this.isEntityForeign
          );
          let countryList: any[] = COUNTRY_CODES;

          let selectedCurrency = {
            currency: this._entityDetails[0].currency,
            currencySymbol: this._entityDetails[0].currency_symbol,
            countryCode: this._entityDetails[0].entity_country_code,
            code: countryList.find(
              (country) =>
                country.dial_code ===
                  this._entityDetails[0].entity_country_code &&
                country.currency === this._entityDetails[0].currency
            )?.code,
          };
          sessionStorage.setItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
            JSON.stringify(selectedCurrency)
          );
        }

        sessionStorage.setItem(
          "shop_service_status",
          this._entityDetails[0].shopServiceStatus
        );
        sessionStorage.setItem(
          "home_service_status",
          this._entityDetails[0].homeServiceStatus
        );
        sessionStorage.setItem(
          "virtual_service_status",
          this._entityDetails[0].virtual_service_status
        );

        // this.loader = false
        // this.loaderService.showLoader = false;
        this.authService.setUserRole(
          this._entityDetails[0].is_owner == 1 ? "owner" : "employee"
        );
        if (this._entityDetails[0].is_owner == 1) {
          this._apiService.getFunctionalityByEntityId(this.entityHashId);
        } else {
          this._apiService.getFunctionalityByEmployeeId(
            this._entityDetails[0].employee_hash_id
          );
        }
        if (this._entityDetails[0].is_owner == 0) {
          this.receiverHashId = this._entityDetails[0].ownerProfileHashId;
        }
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_FEATURE_WISE_COUNTS
      ) {
        this.entityFeatureWiseCounts = {};
        if (resData.result) {
          this.entityFeatureWiseCounts = resData.result[0];
        }

        //--------------- modal to show newly created business success --------------------
        if (
          localStorage.getItem("newlyCreatedBusinessHash") &&
          localStorage.getItem("newlyCreatedBusinessHash") != "null"
        ) {
          let bHash = localStorage.getItem("newlyCreatedBusinessHash");
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "600px",
            data: {
              title: "SUCCESS!",
              message:
                "Your business created successfully. Now upload business and shop ownership documents in Documents section. Once they will be verified your business will be ready to get bookings from People mobile apps and websites.",
              okbtn: " Go to Documents",
              cancelbtn: "Ok",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
            if (result) {
              localStorage.removeItem("newlyCreatedBusinessHash");
              this.router.navigate(["/businesses", "details", "documents"], {
                queryParams: { entityHash: bHash },
              });
            } else {
              localStorage.removeItem("newlyCreatedBusinessHash");
            }
          });
        }
        // ---------------------xxxxxxxxxxxxxxxxxxxx-----------------------

        this.loader = false;
        this.loaderService.showLoader = false;
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID
      ) {
        if (resData.result && resData.result != null) {
          this.appFunctionality = resData.result;

          const index = this.appFunctionality.findIndex(
            (item: any) => item.functionality_name == "Whatsapp share"
          );
          console.log(index);
          if (index != -1) {
            if (this.appFunctionality[index].type == 1) {
              localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, "1");
            } else if (this.appFunctionality[index].type == 2) {
              const date = new Date(
                this.appFunctionality[index].accessibility_end_date
              );
              // const date = new Date('2023-11-01T00:00:00.000Z');

              const newdate = new Date();

              date.setHours(0, 0, 0, 0);
              newdate.setHours(0, 0, 0, 0);

              if (newdate <= date) {
                localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, "1");
              } else {
                localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, "0");
              }
            }
          } else {
            localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, "0");
          }

          // BUSINESS POST IMAGE SET LIMIT
          const indexforbusinesspostimage = this.appFunctionality.findIndex(
            (item: any) =>
              item.functionality_name == "Upload image in business post"
          );
          if (indexforbusinesspostimage != -1) {
            sessionStorage.setItem(
              SM_CONSTANTS.BUSINESS_POST_IMAGE_LIMIT,
              this.appFunctionality[indexforbusinesspostimage].type == 1
                ? this.appFunctionality[indexforbusinesspostimage].free_limit
                : this.appFunctionality[indexforbusinesspostimage].paid_limit
            );
          }

          // BUSINESS POST VIDEO SET LIMIT
          const indexforbusinesspostvideo = this.appFunctionality.findIndex(
            (item: any) =>
              item.functionality_name == "Upload video in business post"
          );
          if (indexforbusinesspostvideo != -1) {
            sessionStorage.setItem(
              SM_CONSTANTS.BUSINESS_POST_VIDEO_LIMIT,
              this.appFunctionality[indexforbusinesspostvideo].type == 1
                ? this.appFunctionality[indexforbusinesspostvideo].free_limit
                : this.appFunctionality[indexforbusinesspostvideo].paid_limit
            );
          }
          // BUSINESS IMAGE SET LIMIT
          const indexforbusinessImage = this.appFunctionality.findIndex(
            (item: any) => item.functionality_name == "Upload image for entity"
          );
          if (indexforbusinessImage != -1) {
            sessionStorage.setItem(
              SM_CONSTANTS.BUSINESS_IMAGE_LIMIT,
              this.appFunctionality[indexforbusinessImage].type == 1
                ? this.appFunctionality[indexforbusinessImage].free_limit
                : this.appFunctionality[indexforbusinessImage].paid_limit
            );
          }

          sessionStorage.setItem(
            "tempAppFunctionality",
            JSON.stringify(this.appFunctionality)
          );
          this._apiService.getEntityFeatureWiseCounts(this.entityHashId);
        }
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID
      ) {
        this.employeeFunctionalityList = [];
        if (resData.result) {
          this.employeeFunctionalityList = resData.result;

           sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,this.getSectionVisibleStatus('Shop/In-Premise Invoicing') == true ? '1' : '0')
          sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,this.getSectionVisibleStatus('Home service invoicing') == true ? '1' : '0')
          sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,this.getSectionVisibleStatus('Virtual service invoicing') == true ? '1' : '0')

          sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS,this.getSectionVisibleStatus('Shop/In-Premise operation') == true ? '1' : '0')
          sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS,this.getSectionVisibleStatus('Home service operation') == true ? '1' : '0')
          sessionStorage.setItem(SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS,this.getSectionVisibleStatus('Virtual service operation') == true ? '1' : '0')
          

        }

        this._apiService.getFunctionalityByEntityId(this.entityHashId);
      }

      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SERVICES
      ) {
        if (resData.result) {
          this._apiService.getEntityDetails(this.entityHashId);
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SET_EMPLOYEE_DUTY_DATA
      ) {
        if (resData.result) {
          this._apiService.getEntityDetails(this.entityHashId);
        }
      }

      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE
      ) {
        // this.chatThreads = []
        if (resData.result) {
          resData.result.forEach((element: any) => {
            if (element.senderInfo && element.receiverInfo) {
              if (element.senderInfo && typeof element.senderInfo == "string") {
                element.senderInfo = JSON.parse(element.senderInfo);
              }
              if (
                element.receiverInfo &&
                typeof element.receiverInfo == "string"
              ) {
                element.receiverInfo = JSON.parse(element.receiverInfo);
              }

              if (
                (element.senderInfo.hash_id == this.senderHashId &&
                  element.receiverInfo.hash_id == this.receiverHashId &&
                  element.entity_public_hash_id ==
                    localStorage.getItem(
                      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                    )) ||
                (element.senderInfo.hash_id == this.receiverHashId &&
                  element.receiverInfo.hash_id == this.senderHashId &&
                  element.entity_public_hash_id ==
                    localStorage.getItem(
                      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
                    ))
              ) {
                this.previousChatHash = element.hash_id;
              }
            }
          });
          console.log(this.previousChatHash);
        }
        this.loaderService.showLoader = false;
        let data = {
          title: this._entityDetails[0].entityName,
          ref: this.dialog,
          previousChatHash: this.previousChatHash,
          employeeImage: this.businessDefaultImage,
          employeeHash: this.receiverHashId,
        };
        this.dialogService.openFullScreenDialog(
          EmployeeOnlySendMessageComponent,
          data
        );
      }
    });
  }
  onToggleChange(event: any, serviceType: any) {
    // -------- CHECK LOGIC-----------
    if (event.checked) {
      // home
      if (serviceType == 0) {
        this.toShowCheckHome = 1;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: 1,
          shop_service_status: this._entityDetails[0].shopServiceStatus,
          virtual_service_status: this._entityDetails[0].virtual_service_status,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
      //shop
      else if (serviceType == 1) {
        this.toShowCheckShop = 1;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: this._entityDetails[0].homeServiceStatus,
          shop_service_status: 1,
          virtual_service_status: this._entityDetails[0].virtual_service_status,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
      //virtual
      else if (serviceType == 2) {
        this.toShowCheckVirtual = 1;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: this._entityDetails[0].homeServiceStatus,
          shop_service_status: this._entityDetails[0].shopServiceStatus,
          virtual_service_status: 1,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
    }

    // -------- UNCHECK LOGIC -------------
    else if (!event.checked) {
      //home
      if (serviceType == 0) {
        this.toShowCheckHome = 0;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: 0,
          shop_service_status: this._entityDetails[0].shopServiceStatus,
          virtual_service_status: this._entityDetails[0].virtual_service_status,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
      //shop
      else if (serviceType == 1) {
        this.toShowCheckShop = 0;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: this._entityDetails[0].homeServiceStatus,
          shop_service_status: 0,
          virtual_service_status: this._entityDetails[0].virtual_service_status,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
      //virtual
      else if (serviceType == 2) {
        this.toShowCheckVirtual = 0;
        let data = {
          entity_hash: this.entityHashId,
          entity_type: this._entityDetails[0].entity_type,
          individual_gender: this._entityDetails[0].provider_gender,
          service_target_type: this._entityDetails[0].service_target_type,
          home_service_status: this._entityDetails[0].homeServiceStatus,
          shop_service_status: this._entityDetails[0].shopServiceStatus,
          virtual_service_status: 0,
          revenue_mode: this._entityDetails[0].revenue_model,
        };
        this.loaderService.showLoader = true;
        this._apiService.updateEntityServices(data);
      }
    }
  }

  onChangeDutyStatus(event: any) {
    this.loaderService.showLoader = true;
    if (this.platform.is("capacitor")) {
      this.locationService.getCurrentLocationForMobile().then(
        (address) => {
          // console.log("address received for employee:::::>>>>>>>>>>",JSON.stringify(address));
          let obj = {
            employee_hash_id: this._entityDetails[0].employee_hash_id,
            entity_hash_id: this._entityDetails[0].hashId,
            lat: address.latitude,
            lng: address.longitude,
            address: address.formattedAddress,
            entry_type: event.checked ? 1 : 0,
            duty_status: event.checked ? 1 : 0,
            time: this.formatDateString(),
          };
          console.log(JSON.stringify(obj));
          this._apiService.setEmployeeDutyData(obj);
        },
        (error) => {
          this.loaderService.showLoader = false;
          console.error("Error getting location:", error);
          this.toShowCheckDutyStatus =
            this._entityDetails[0].employee_entry_type;
          this.alertService.onOpenSnackbar(
            "Please allow location permission first to register duty status.",
            5000,
            "OK"
          );
        }
      );
    } else {
      this.locationService.getCurrentLocation().then(
        (address) => {
          // console.log("address received for employee:::::>>>>>>>>>>",JSON.stringify(address));
          let obj = {
            employee_hash_id: this._entityDetails[0].employee_hash_id,
            entity_hash_id: this._entityDetails[0].hashId,
            lat: address.latitude,
            lng: address.longitude,
            address: address.formattedAddress,
            entry_type: event.checked ? 1 : 0,
            duty_status: event.checked ? 1 : 0,
            time: this.formatDateString(),
          };
          console.log(JSON.stringify(obj));
          this._apiService.setEmployeeDutyData(obj);
        },
        (error) => {
          this.loaderService.showLoader = false;
          console.error("Error getting location:", error);
          this.toShowCheckDutyStatus =
            this._entityDetails[0].employee_entry_type;
          this.alertService.onOpenSnackbar(
            "Please allow location permission first to register duty status.",
            5000,
            "OK"
          );
        }
      );
    }
  }

  ngOnInit(): void {
    sessionStorage.removeItem("tempAppFunctionality");
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.loader = true;
      this.entityHashId = data.entityHash;
      this.loaderService.showLoader = true;
      this._apiService.getEntityDetails(this.entityHashId);
    });
  }

  viewdetailsv() {
    console.log("business-details-owners");
    this.router.navigate(["/businesses/details/extended-details"], {
      queryParams: { entityHash: this.entityHashId },
    });
  }

  opencurrentpack() {
    this.router.navigate(["current-pack-recharge"]);
  }

  //----------------- open sections cards -----------------

  openServiceTimings(type: any) {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Shop/In-Premise timings"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "service-timings"], {
        queryParams: {
          serviceType: type,
          entityHash: this._entityDetails[0].hashId,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "service-timings"], {
          queryParams: {
            serviceType: type,
            entityHash: this._entityDetails[0].hashId,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

  openEmployees() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Employee management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "employees"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "employees"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

  openServices() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Services & Packages"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "services"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          enPubHash: this._entityDetails[0].entPubHash,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "services"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            enPubHash: this._entityDetails[0].entPubHash,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openProducts() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Product handling"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "products"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          enPubHash: this._entityDetails[0].entPubHash,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "products"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            enPubHash: this._entityDetails[0].entPubHash,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

  openCustomers() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Customer management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "customers"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "customers"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openMembers() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Member management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "members"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "members"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

 openInvoices() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Invoice history"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "all-invoices"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          eph: this._entityDetails[0].entPubHash,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "all-invoices"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            eph: this._entityDetails[0].entPubHash,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openFeedback() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Feedback management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "feedback"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          entityName: this._entityDetails[0].entityName,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "feedback"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            entityName: this._entityDetails[0].entityName,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openQRCode() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "QR Code processing"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "qr-code"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "qr-code"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openPlanAndRenew() {
    sessionStorage.setItem(
      "tempAppFunctionality",
      JSON.stringify(this.appFunctionality)
    );
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Current Plan & Renew"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "plan-and-renew"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "plan-and-renew"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
      }
    }
  }

  openExpenses() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Expense management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "expenses"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "expenses"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openInventory() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Inventory management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "inventory"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "inventory"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openPurchaseList() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Purchase handling"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "purchase-list"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "purchase-list"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openBusinessPost() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Business posting"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "post"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          entPubHash: this._entityDetails[0].entPubHash,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "post"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            entPubHash: this._entityDetails[0].entPubHash,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openFollowers() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "All followers"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "followers"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "followers"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openReports() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Reports & Analysis"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "reports"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "reports"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openSupportTicket() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Support ticket"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "support-ticket"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "support-ticket"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openBookings(type: string) {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Shop/In-Premise operation"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "bookings"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          eph: this._entityDetails[0].entPubHash,
          bookingType: type,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "bookings"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            eph: this._entityDetails[0].entPubHash,
            bookingType: type,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

  openTaxAndGST() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Tax management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "tax-and-gst"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "tax-and-gst"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        // alert('This is a premium functionality and you need to purchase a paid pack for using it.')
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
        // dialogRef.afterClosed().subscribe(result=>{
        //   console.log(result);
        //   if(result){

        //   }
        // })
      }
    }
  }
  openDiscount() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Discount processing"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "discount"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "discount"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openCoupons() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Coupon management"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      sessionStorage.setItem("cbu", this._entityDetails[0].webUrl);
      sessionStorage.setItem("cbcc", this._entityDetails[0].currency_symbol);
      this.router.navigate(["/businesses", "details", "coupons"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        sessionStorage.setItem("cbu", this._entityDetails[0].webUrl);
        sessionStorage.setItem("cbcc", this._entityDetails[0].currency_symbol);
        this.router.navigate(["/businesses", "details", "coupons"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
    // this.router.navigate(["/businesses", "details", "coupons"], {
    //             queryParams: { entityHash: this._entityDetails[0].hashId },
    //           });
  }
  openOnlinePayments() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Online payments"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "online-payments"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          isEntityForeign: this.isEntityForeign,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "online-payments"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            isEntityForeign: this.isEntityForeign,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openDocuments() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Documents handling"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "documents"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "documents"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }
  openBookingHistory() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Booking history"
    );
    console.log(index);

    if (this.appFunctionality[index].type == 1) {
      this.router.navigate(["/businesses", "details", "booking-history"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          eph: this._entityDetails[0].entPubHash,
        },
      });
    } else if (this.appFunctionality[index].type == 2) {
      const date = new Date(
        this.appFunctionality[index].accessibility_end_date
      );
      // const date = new Date('2023-11-01T00:00:00.000Z');

      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if (newdate <= date) {
        this.router.navigate(["/businesses", "details", "booking-history"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            eph: this._entityDetails[0].entPubHash,
          },
        });
      } else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          data: {
            title: "Alert",
            message:
              "This is a premium functionality and you need to purchase a paid pack for using it.",
            okbtn: "Buy Pack",
            cancelbtn: "Cancel",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            sessionStorage.setItem(
              "tempAppFunctionality",
              JSON.stringify(this.appFunctionality)
            );
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        });
      }
    }
  }

  shareBusiness() {
    // window.open(this._entityDetails[0].webUrl, '_blank');
    this.dialog.open(CopyLinkCompComponent, {
      width: "700px",
      data: {
        title: "Your business website",
        ref: this.dialog,
        data: this._entityDetails[0].webUrl,
      },
    });
  }

  openMySalary() {
    this.router.navigate(["/businesses", "details", "my-salary"], {
      queryParams: {
        entityHash: this._entityDetails[0].hashId,
        employeeHash: this._entityDetails[0].employee_hash_id,
      },
    });
  }

  openMyCredits() {
    this.router.navigate(["/businesses", "details", "my-credits"], {
      queryParams: {
        entityHash: this._entityDetails[0].hashId,
        employeeHash: this._entityDetails[0].employee_hash_id,
      },
    });
  }

  openMyAttendance() {
    this.router.navigate(["/businesses", "details", "my-attendance"], {
      queryParams: {
        entityHash: this._entityDetails[0].hashId,
        employeeHash: this._entityDetails[0].employee_hash_id,
      },
    });
  }

  openpromotioncampaign() {
    // this.router.navigate(["/businesses", "details", "promotion-campaign"], {
    //         queryParams: { entityHash: this._entityDetails[0].hashId },
    //       });

    const index = this.appFunctionality.findIndex(
      (item: any) =>
        item.functionality_name == "Promotion management"
    );
    console.log(index);
    if (index != -1) {
      if (this.appFunctionality[index].type == 1) {
        this.router.navigate(["/businesses", "details", "promotion-campaign"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      } else if (this.appFunctionality[index].type == 2) {
        const date = new Date(
          this.appFunctionality[index].accessibility_end_date
        );
        // const date = new Date('2023-11-01T00:00:00.000Z');

        const newdate = new Date();

        date.setHours(0, 0, 0, 0);
        newdate.setHours(0, 0, 0, 0);

        if (newdate <= date) {
          this.router.navigate(
            ["/businesses", "details", "promotion-campaign"],
            {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            }
          );
        } else {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            data: {
              title: "Alert",
              message:
                "This is a premium functionality and you need to purchase subscription for using it.",
              okbtn: "Buy Pack",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
            if (result) {
              sessionStorage.setItem(
                "tempAppFunctionality",
                JSON.stringify(this.appFunctionality)
              );
              this.router.navigate(
                ["/businesses", "details", "plan-and-renew"],
                {
                  queryParams: { entityHash: this._entityDetails[0].hashId },
                }
              );
            }
          });
        }
      }
    }
  }

  openMessages() {
    this.loaderService.showLoader = true;
    this._apiService.getMessagesByIDForEmployee();
  }

  openJoiningQueryList(serviceType: any) {
    this.router.navigate(["/businesses", "details", "joining-query-list"], {
      queryParams: {
        entityHash: this.entityHashId,
        serviceType: serviceType,
        eph: this._entityDetails[0].entPubHash,
      },
    });
  }

  checkTemplateHashes(parentArray: any, templateHashes: any) {
    // Create a set of template hashes for faster lookup
    const templateHashSet = new Set(templateHashes);

    // Iterate through the parent array and check for matching hash_id
    for (let item of parentArray) {
      if (templateHashSet.has(item.template_hash)) {
        return true;
      }
    }
    return false;
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


  openloyaltyconfigure() {
    const index = this.appFunctionality.findIndex(
      (item: any) => item.functionality_name == "Loyalty Rewards",
    );
    console.log(index);

    if (index != -1) {
      if (this.appFunctionality[index].type == 1) {
        this.router.navigate(["/businesses", "details", "loyalty-configurer"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            eph: this._entityDetails[0].entPubHash,
          },
        });
      } else if (this.appFunctionality[index].type == 2) {
        const date = new Date(
          this.appFunctionality[index].accessibility_end_date,
        );
        // const date = new Date('2023-11-01T00:00:00.000Z');

        const newdate = new Date();

        date.setHours(0, 0, 0, 0);
        newdate.setHours(0, 0, 0, 0);

        if (newdate <= date) {
          this.router.navigate(
            ["/businesses", "details", "loyalty-configurer"],
            {
              queryParams: {
                entityHash: this._entityDetails[0].hashId,
                eph: this._entityDetails[0].entPubHash,
              },
            },
          );
        } else {
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            data: {
              title: "Alert",
              message:
                "This is a premium functionality and you need to purchase a paid pack for using it.",
              okbtn: "Buy Pack",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
            },
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
            if (result) {
              sessionStorage.setItem(
                "tempAppFunctionality",
                JSON.stringify(this.appFunctionality),
              );
              this.router.navigate(
                ["/businesses", "details", "plan-and-renew"],
                {
                  queryParams: { entityHash: this._entityDetails[0].hashId },
                },
              );
            }
          });
        }
      }
    }
  }

  //----------------- open sections cards -----------------

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

    getSectionVisibleStatus(name: string) {
    if(this._entityDetails[0].is_owner == 1){
      return true
    }else{
      const list = this.employeeFunctionalityList;
      if (!Array.isArray(list)) return false;
  
      const found = list.find((fn: any) => fn.functionality_name === name);
      return found?.access_status === 1 ? true : false;

    }
  }
}
